import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { Select, StyledAsyncCreatableSelect, StyledCreatableSelect, AsyncSelect, MultiSelect, AsyncMultiSelect, CreatableMultiSelect, AsyncCreatableMultiSelect, } from '.';
import { InputIconsRenderer } from '../common';
import { isErrorVisible } from '../Error';
import { FinalFormFormField } from '../FormField';
/* eslint-enable @typescript-eslint/no-explicit-any */
const createSelectField = (Component) => {
    const FormComponent = (props) => {
        const { input, meta, label, labelTooltip, required, isDisabled, disabled: disabledProp, renderError, iconStart, iconEnd, withTouched, onChange, ...restProps } = props;
        const handleChange = useCallbackRef((value, actionMeta) => {
            input.onChange(value);
            // @ts-expect-error: isMulti false vs true
            onChange?.(value, actionMeta);
        });
        const disabled = isDisabled || disabledProp;
        const { error, touched, submitError } = meta;
        return (_jsx(FinalFormFormField, { meta: meta, name: input.name, disabled: disabled, required: required, label: label, labelTooltip: labelTooltip, renderError: renderError, withTouched: withTouched, children: _jsx(InputIconsRenderer, { iconStart: iconStart, iconEnd: iconEnd, children: _jsx(Component, { isDisabled: disabled, error: isErrorVisible(error, touched, withTouched, submitError), ...input, 
                    // PropsValue doesn't consider the isMulti value
                    value: input.value, onChange: handleChange, ...restProps }) }) }));
    };
    return React.memo(FormComponent);
};
export const SelectField = createSelectField(Select);
export const AsyncCreatableSelectField = createSelectField(StyledAsyncCreatableSelect);
export const CreatableSelectField = createSelectField(StyledCreatableSelect);
export const CreatableMultiSelectField = createSelectField(CreatableMultiSelect);
export const AsyncCreatableMultiSelectField = createSelectField(AsyncCreatableMultiSelect);
export const AsyncSelectField = createSelectField(AsyncSelect);
export const MultiSelectField = createSelectField(MultiSelect);
export const AsyncMultiSelectField = createSelectField(AsyncMultiSelect);
